class MCartRemoveButton extends HTMLElement {
	constructor() {
		super(), this.addEventListener("click", (t => {
			t.preventDefault();
			(this.closest("m-cart") || this.closest("m-cart-drawer-items")).updateQuantity(this.dataset.index, 0)
		}))
      freeShippingMsg();
      // freeGiftMsg();
     setTimeout(function(){
        // welcomeGift();
     },500);
	}
}
customElements.define("m-cart-remove-button", MCartRemoveButton);
class MCartTemplate extends HTMLElement {
	constructor() {
		super(), this.cartUpdateUnsubscriber = void 0, this.isCartPage = "cart" === MinimogSettings.templateName, this.cartDrawerWrapper = document.querySelector("m-cart-drawer"), this.cartDrawerInner = document.querySelector(".m-cart-drawer__inner"), this.mainCartItems = this.querySelector("[data-minimog-cart-items]"), this.cartSubTotal = this.querySelector("[data-cart-subtotal]"), this.cartDiscount = this.querySelector("[data-minimog-cart-discounts]"), this.giftWrapping = this.querySelector("[data-minimog-gift-wrapping]");
		let t = this.cartDrawerInner;
		this.isCartPage && (t = document.body), this.loading = new MinimogLibs.AnimateLoading(t, {
			overlay: t
		}), this.rootUrl = window.Shopify.routes.root;
		const e = debounce((t => {
			"id" !== t.target.name && this.onChange(t)
		}), 300);
		this.isCartPage ? this.mainCartItems.addEventListener("change", e.bind(this)) : this.addEventListener("change", e.bind(this)), MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t => {
			this.getCart().then((t => {
				this.updateCartCount(t.item_count)
			}))
		}))
		window.cart = this;
	}
	updateCartCount(t) {
		document.querySelectorAll(".m-cart-count-bubble").forEach((e => {
			t > 0 ? (e.textContent = t, e.classList.remove("m:hidden")) : e.classList.add("m:hidden")
		}))
	}
	getCart() {
		return fetchJSON(this.rootUrl + "cart.json")
	}
	connectedCallback() {
		this.cartUpdateUnsubscriber = MinimogEvents.subscribe(MinimogTheme.pubSubEvents.cartUpdate, (t => {
			"main-cart-items" !== t.source && this.onCartUpdate()
		}))
	}
	disconnectedCallback() {
		this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber()
	}
	onCartUpdate(t = !0) {
		const {
			routes: e
		} = window.MinimogSettings;
		fetch(`${e.cart}?section_id=cart-template`).then((t => t.text())).then((e => {
			const i = (new DOMParser).parseFromString(e, "text/html"),
				n = i.querySelector("[data-minimog-cart-items]"),
				r = i.querySelector("[data-cart-subtotal]"),
				a = i.querySelector("[data-minimog-cart-discounts]"),
				s = i.querySelector("[data-minimog-gift-wrapping]");
			this.isCartPage && (this.mainCartItems.innerHTML = n.innerHTML, t && (this.cartSubTotal.innerHTML = r.innerHTML, this.cartDiscount.innerHTML = a.innerHTML, this.giftWrapping.innerHTML = s.innerHTML), window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart())
		})).catch((t => {}))
	}
	onChange(t) {
		this.updateQuantity(t.target.dataset.index, t.target.value, document.activeElement.getAttribute("name"))
	}
	updateQuantity(t, e, i) {
     
		this.loading.start();
		const {
			routes: n
		} = window.MinimogSettings, r = JSON.stringify({
			line: t,
			quantity: e,
			sections: this.getSectionsToRender().map((t => t.section)),
			sections_url: window.location.pathname
		});
		fetch(`${n.cart_change_url}`, {
			...fetchConfig(),
			body: r
		}).then((t => t.text())).then((e => {
			const i = JSON.parse(e);
			let n = document.getElementById(`MinimogDrawer-quantity-${t}`);
			this.isCartPage && (n = MinimogTheme.config.mqlMobile ? document.querySelector(`.MinimogQuantity-${t}.MinimogQuantity-mobile`) : document.querySelector(`.MinimogQuantity-${t}.MinimogQuantity-desktop`));
			const r = document.querySelectorAll(".m-cart-item");
			if (i.errors) return this.loading.finish(), n.value = n.getAttribute("value"), void this.updateLiveRegions(t, i.errors);
			this.classList.toggle("m-cart--empty", 0 === i.item_count), this.cartDrawerWrapper && this.cartDrawerWrapper.classList.toggle("m-cart--empty", 0 === i.item_count), this.getSectionsToRender().forEach((t => {
				(document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)).innerHTML = this.getSectionInnerHTML(i.sections[t.section], t.selector)
			}));
			const a = i.items[t - 1] ? i.items[t - 1].quantity : void 0;
			let s = "";
			r.length === i.items.length && a !== parseInt(n.value) && (s = void 0 === a ? window.MinimogStrings.cartError : window.MinimogStrings.quantityError.replace("[quantity]", a)), this.updateLiveRegions(t, s), MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, {
				...i,
				source: "main-cart-items"
			})
		})).catch((() => {})).finally((() => {
			this.loading.finish()
		}))
      freeShippingMsg();
      // freeGiftMsg();
	}
	updateLiveRegions(t, e) {
		let i = document.getElementById(`MinimogCartDrawer-Item-${t}`);
		this.isCartPage && (i = document.getElementById(`MinimogCart-Item-${t}`)), "" !== e && i && MinimogTheme.Notification.show({
			target: i,
			type: "warning",
			message: e
		})
	}
	getSectionInnerHTML(t, e) {
		return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
	}
	getSectionsToRender() {
		return [{
			id: "MinimogCart",
			section: "cart-template",
			selector: "[data-minimog-cart-items]"
		}, {
			id: "MinimogCart",
			section: "cart-template",
			selector: "[data-cart-subtotal]"
		}, {
			id: "MinimogCart",
			section: "cart-template",
			selector: "[data-minimog-cart-discounts]"
		}, {
			id: "MinimogCart",
			section: "cart-template",
			selector: "[data-minimog-gift-wrapping]"
		}]
	}
}
customElements.define("m-cart", MCartTemplate);


function freeShippingMsg(){

 setTimeout(function(){
  fetch('/cart.js')
    .then((resp) => resp.json())
    .then((cart) => {
//   console.log("called");
   if(cart.total_price > 0){
    var element = document.getElementById("free_shipment");
    element.classList.remove("hidden");
  $('.upsell_block').removeClass('hidden');
    var priceCart = cart.total_price;
    // console.log(priceCart);
    $("#cart_count_inner").text(cart.item_count);

  // var minOrderValue = $('#valFreeShip').attr('data-freeshipment');
  
      const link = document.querySelector('#valFreeShip');
      var minOrderValue = link.getAttribute('data-freeshipment');
    //   console.log(minOrderValue);
        if (priceCart >= minOrderValue){
          // $('#valFreeShip').html("<div class='free_ship_msg'>Yay! 🎉 You have qualified for Free Shipping!</div>");
          document.getElementById("valFreeShip").innerHTML = "<div class='free_ship_msg'>Yay! 🎉 You have qualified for Free Shipping!</div>";
        
        }else{
          let percent = priceCart / minOrderValue * 100;
          
          let left = formatMoney((minOrderValue - priceCart), MinimogSettings.money_format);
        //   console.log(left);
          // $('#valFreeShip').html("<div class='free_ship_msg'>You are <span>"+ left +"</span> away from Free Standard Shipping.</div>");
          document.getElementById("valFreeShip").innerHTML = "<div class='free_ship_msg'>ADD <span>"+ left +"</span> MORE FOR FREE SHIPPING.</div>";
          
          
           
        }
        var g = document.querySelector("progress");
          // Set the value of progress element
          g.setAttribute("value", priceCart);
        
    }else{
      $("#cart_count_inner").text(0);
	  $(".m-header__right .m-cart-icon-bubble span").text(0);
	  
	  $(".m-header__right .m-cart-icon-bubble span").removeClass('m:hidden');
       $('.upsell_block').addClass('hidden');
        var element = document.getElementById("free_shipment");
        element.classList.add("hidden");
    }
  });
 },1000);
}

function freeGiftMsg(){

 setTimeout(function(){
  fetch('/cart.js')
    .then((resp) => resp.json())
    .then((cart) => {

   if(cart.total_price > 0 || cart.item_count > 0){

     var hasFreeGift = false;
     
      const link = document.querySelector('#valFreeGift');
      const freeGiftLabel = document.querySelector('#freeGiftLabel');
      
      
      var minOrderValueGift = link.getAttribute('data-freegift');
      var giftTit = freeGiftLabel.getAttribute('data-freeTit');
      var giftPrc = freeGiftLabel.getAttribute('data-freePrc');
      var giftProductId = freeGiftLabel.getAttribute('data-freegiftId');
      var giftProductKey = freeGiftLabel.getAttribute('data-freegiftKey');

       // console.log(cart);
     cart.items.forEach(function(product, index) { 
       if(giftProductId == product.product_id && typeof(product.properties['_masterProduct'] == 'undefined')){
  
           if(cart.item_count == 1 && giftProductId == product.product_id){
             // remove free gift 
             c_remove(product.key);
               freeGiftMsg();
         
           }else if(cart.item_count > 1 && giftProductId == product.product_id && cart.total_price < minOrderValueGift){
              c_remove(product.key);
           }else{
             
               hasFreeGift = true;
             
              var hideElement = document.getElementById("free_gift");
              hideElement.classList.add("hidden");
          
              var hideBoxgift = document.getElementById("giftBox");
              hideBoxgift.classList.add("hidden");
              var priceCart = cart.total_price;
             var customTxt = "";
              // customMsg(customTxt, priceCart);
             
           }
         
       }
     });

     if(hasFreeGift == false && cart.total_price > 0)
     {
      var element = document.getElementById("free_gift");
      element.classList.remove("hidden");
  
      var boxgift = document.getElementById("giftBox");
      boxgift.classList.remove("hidden");

     
      $('.upsell_block').removeClass('hidden');
      var priceCart = cart.total_price;
      // console.log(priceCart);
      $("#cart_count_inner").text(cart.item_count);

 
        if (priceCart >= minOrderValueGift){
        
          document.getElementById("valFreeGift").innerHTML = "<div class='free_gift_msg'> Congrats! you have unlocked <span class='gift_title'>1 free "+ giftTit +"</span>.</div>";
          document.getElementById("freeGiftLabel").innerHTML = "<p class='free_gift_remain'> Congrats! you have unlocked <span class='gift_title'>1 free "+ giftTit +"</span>.</p>";
          document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").disabled = false;
          document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.add('activate');
          document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.remove('deactivate');
          var customTxt = "Add another and get <span>Free Shipping</span>";
          // customMsg(customTxt, priceCart);
        
        }else{
          let percent = priceCart / minOrderValueGift * 100;
        
          let left = formatMoney((minOrderValueGift - priceCart), MinimogSettings.money_format);
      
          document.getElementById("valFreeGift").innerHTML = "<div class='free_gift_msg'>ADD <span>"+ left +"</span> MORE FOR GIFT.</div>";
          document.getElementById("freeGiftLabel").innerHTML = "<p class='free_gift_remain'>Spend another <span>"+ left +"</span> to get this gift worth <span class='gift_price'>"+ giftPrc +"</span>.</p>";
          document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").disabled = true;
          document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.add('deactivate');
          document.querySelector(".free_gift_wrp .m-add-to-cart.m-button").classList.remove('activate');
          var customTxt = "Add another and get <span>Free Shipping & Gift</span>";
          // customMsg(customTxt, priceCart);
           
        }
        var gift = document.querySelector(".progress_gift");
          // Set the value of progress element
          gift.setAttribute("value", priceCart);
    }
    }else{
      $("#cart_count_inner").text(0);
	  $(".m-header__right .m-cart-icon-bubble span").text(0);
	  
	  $(".m-header__right .m-cart-icon-bubble span").removeClass('m:hidden');
       $('.upsell_block').addClass('hidden');
        var element = document.getElementById("free_gift");
        element.classList.add("hidden");

       var boxgift = document.getElementById("giftBox");
       boxgift.classList.add("hidden");
    }
  });
 },1000);
}


function c_remove(prodID) {
  console.log('-------------------------------------------------------------------------');
  console.log(prodID);
  console.log('-------------------------------------------------------------------------');
 
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {'quantity' : 0, 'id': prodID},
    success: function (data) 
    {
       window.cartDrawer.onCartDrawerUpdate();
     
    },
    error: function(err) {console.log(err)}
  });

  
}
function customMsg(txt, PriceCart) {

  const linkd = document.querySelector('#valFreeShip');
  var minOrderValueShipping = linkd.getAttribute('data-freeshipment');
  
  var examples = document.querySelectorAll(".add_custom_txt");
  
  if(PriceCart >= minOrderValueShipping){
   
    examples.forEach(example => {
    example.innerHTML = '';
  });
  }else{
    examples.forEach(example => {
    example.innerHTML = txt;
  });
  }
  
 
}